<template>
    <div class="live_container">
      <div class="intel_part01">
        <div>
          <p>直播可以加速分享推广带来超过100倍的潜在商机</p>
          <p>助力实现企业弯道超车</p>
          <button @click="showLiveDialog=true">立即试用</button>
        </div>
      </div>
      <div class="live_part02">
        <div>
          <div>
            <img src="../assets/images/live01.png" alt="">
            <div>
              <h1><span>为什么</span></h1>
              <ul>
                <li>直播课堂、企业培训、产品发布会渠道招商、员工大会、峰会论</li>
                <li>坛都在网络直播</li>
              </ul>
            </div>
            <div>
              <h1><span>因&nbsp;为</span></h1>
              <ul>
                <li>超过3亿人次观看商务直播</li>
                <li>通过直播进行直播和决策效率至少提升85%</li>
                <li>直播可以加速分享和推广带来超过1000倍的潜在机会</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="live_part03">
        <div>
          <div class="live_question_left">
            <p>全心全意经营推广</p>
            <p>但数据、流量、粉丝都在为他人做嫁衣？</p>
            <p>企业没有一套完善营销推广系统？</p>
          </div>
          <div class="live_question_right">
            <h2><span>微信直播平台<b></b></span></h2>
            <p>博商直播为客户提供一整套完整的微信营销直播系统。企业的内容、流量、粉丝和数据完全自属,不为别人做嫁衣,还能结合博商ERP、博商微客服等系统,协助企业涨粉变现,提高营销推广效率。
            </p>
          </div>
        </div>
      </div>
      <div class="live_part04">
        <div>
          <h1 class="live_title">5步实现活动直播就这么简单</h1>
          <div class="live_achieve_first">
            <ul>
              <li>
                <img src="../assets/images/achieve01.png" alt=""><br>
                <span class="live_achieve_serial"><b>1</b>确定需求</span>
              </li>
              <li>
                <img src="../assets/images/achieve02.png" alt=""><br>
                <span class="live_achieve_serial"><b>2</b>平台接口对接</span>
              </li>
              <li>
                <img src="../assets/images/achieve03.png" alt=""><br>
                <span class="live_achieve_serial"><b>3</b>无需下载 分享成交<br>自动结算提成</span>
              </li>
            </ul>
          </div>
          <div class="live_achieve_second">
            <ul>
              <li>
                <img src="../assets/images/achieve04.png" alt=""><br>
                <span class="live_achieve_serial"><b>4</b>博商提供<br><strong class="line_feed">直播解决方案</strong></span>
              </li>
              <li>
                <img src="../assets/images/achieve05.png" alt=""><br>
                <span class="live_achieve_serial"><b>5</b>直播<br><strong class="line_feed">系统上线</strong></span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="live_part05">
        <div>
          <h1 class="live_title_resolve">企业直播7大痛点</h1>
          <h3 class="live_title_resolve_second">博商直播一站式解决直播问题，让直播更简单！</h3>
          <div>
            <ul>
              <li class="resolve01"><strong>难</strong>第三方平台直播流量沉淀转化难博商直播平台搭建企业自有直播平台,不给别人做嫁衣</li>
              <li class="resolve02"><strong>少</strong>户外直播受限制,直播应用场景少。博商直播平台不受网络环境限制,想在哪直播,就在哪直播</li>
              <li class="resolve03"><strong>差</strong>直播卡顿,企业宣传差。博商直播平台多条传输通道同时传输，确保直播稳定</li>
              <li class="resolve04"><strong>糙</strong>直播像素低，产品展示细节粗糙。博商直播平台多元化高清摄像机，画面清晰细致</li>
              <li class="resolve05"><strong>小</strong>线下活动影响小。博商直播平台微信同步直播，一键分享，成交提成，影响力人数放大10倍以上</li>
              <li class="resolve06"><strong>高</strong>经销商大会经常开，次次开会成本高。博商直播平台会议同步直播，随时随地观看，内容清晰传达</li>
              <li class="resolve07"><strong>低</strong>产品说明会，总是重复，效率低。博商直播平台直播后回放，提高说明效果</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="live_part06">
        <div>
          <h1 class="live_title_resolve">博商直播--微信直播营销系统</h1>
          <h3 class="live_title_resolve_second">搭建在微信公众号下的自主自属的营销型直播系统</h3>
          <ul>
            <li>
              <img src="../assets/images/live_wechat01.png" alt="">
              <p>企业可以随时随地自由发起直播，直接面对用户，方便快捷。</p>
            </li>
            <li>
              <img src="../assets/images/live_wechat02.png" alt="">
              <p>系统属于企业自有，内容、数据、粉丝均属于企业自有，不属于任何第三方平台。</p>
            </li>
            <li>
              <img src="../assets/images/live_wechat03.png" alt="">
              <p>系统是搭建在企业的公众号下的，观众可以通过公众号推送的消息、公众号底下的菜单、朋友圈、群内分享以及扫描二维码进行观看。</p>
            </li>
            <li>
              <img src="../assets/images/live_wechat04.png" alt="">
              <p>该系统不仅可实现高清可移动的微信直播，还能利用直播间的营销工具，帮助企业涨粉变现，提高营销效率。</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="live_part07">
        <div>
          <h1 class="live_title_resolve">博商直播--专业清晰移动直播服务商</h1>
          <h3 class="live_title_resolve_second">通过移动互联网技术，帮助客户简单、高效、一站式解决直播问题，让直播更简单！</h3>
          <div>
            <ul>
              <li class="easyLive01 text_right"><strong>直播操作易</strong><br>直播操作简单<br>场景搭建迅速</li>
              <li class="easyLive02 text_left"><strong>传播成本低</strong><br>直播观看无人数限制<br>无线放大活动效果</li>
              <li class="easyLive03 text_right"><strong>传播效率高</strong><br>于微信生态下的直播<br>无需下载<br>一键分享 成交 提成</li>
              <li class="easyLive04 text_left"><strong>直播效果好</strong><br>支持多元化高清摄像机拍摄<br>直播解码压缩<br>画面清晰不卡顿</li>
              <li class="easyLive05 text_right"><strong>独家防盗加密</strong><br>让直播内容更安全</li>
              <li class="easyLive06 text_left"><strong>移动直播强</strong><br>突破网络限制<br>无需网线户外移动直播</li>
            </ul>
          </div>
        </div>
      </div>
      <div class="live_part08">
        <div>
          <h1 class="live_title_resolve">博商直播7大功能</h1>
          <h3 class="live_title_resolve_second">博商直播一站式解决直播问题，让直播更简单</h3>
          <ul>
            <li><strong>直播页面可定制</strong><span>量身打造专属直播现场</span></li>
            <li><strong>分享提交，自动提成结算</strong><span>分享有提交就可设置提成奖励</span></li>
            <li><strong>授权观看</strong><span>精准锁定客户，提升直播价值及私密性</span></li>
            <li><strong>丰富互动插件</strong><span>直播更有趣，观众停留时间长，粘性高</span></li>
            <li><strong>移动直播</strong><span>突破空间限制，直播不受有限网络约束</span></li>
            <li><strong>多账号多平台同步直播</strong><span>多账号，多平台，活动效果直线上升</span></li>
            <li><strong>直播广告植入</strong><span>直播植入视频，滚动字幕，外联广告位多场景切换，传播模式多元化</span></li>
          </ul>
        </div>
      </div>
      <div class="live_part09">
        <div>
          <h1 class="live_title_resolve">博商直播企业直播间应用场景</h1>
          <h3 class="live_title_resolve_second">博商直播一站式解决直播问题，让直播更简单</h3>
          <ul>
            <li><img src="../assets/images/scene01.png" alt=""><span>大型会议</span></li>
            <li><img src="../assets/images/scene02.png" alt=""><span>招商会</span></li>
            <li><img src="../assets/images/scene03.png" alt=""><span>经销商大会</span></li>
            <li><img src="../assets/images/scene04.png" alt=""><span>房地产开盘</span></li>
            <li><img src="../assets/images/scene05.png" alt=""><span>招聘会</span></li>
            <li><img src="../assets/images/scene06.png" alt=""><span>新车发布会</span></li>
            <li><img src="../assets/images/scene07.png" alt=""><span>在线教育</span></li>
            <li><img src="../assets/images/scene08.png" alt=""><span>自驾游</span></li>
            <li><img src="../assets/images/scene09.png" alt=""><span>新品发布</span></li>
            <li><img src="../assets/images/scene10.png" alt=""><span>销售直播</span></li>
          </ul>
        </div>
      </div>
      <div class="live_part10">
          <div>
            <div><span>服务保障</span></div>
            <div><img src="../assets/images/server_line.png" alt=""></div>
            <ul>
              <li><strong>品质保障</strong><span>博商管理科学研究院旗下公司首推应用平台</span></li>
              <li><strong>安全防护</strong><span>拥有国内高级别的安全防护与数据监控措施</span></li>
              <li><strong>多元化服务</strong><span>7*12小时服务响应，专属客户经理，专人运维保障</span></li>
              <li><strong>全面支持</strong><span>多元化集成，同时与微信、APP、CRM无缝对接</span></li>
              <li><strong>自定义功能强大</strong><span>满足不同业态定制化需求</span></li>
            </ul>
          </div>
      </div>
      <my-dialog :show-dialog.sync="showLiveDialog"></my-dialog>
    </div>
</template>

<script>
  import myDialog from '../components/my-dialog'
    export default {
        name: '',
        data:function(){
          return {
            showLiveDialog:false
          }
        },
      components:{myDialog}

    }
</script>



// WEBPACK FOOTER //
// src/components/liveBroadcast.vue